<template>
  <div class="organization-details container">
    <OrganizationDetailsForm
      @edit:organization="edit"
      @update:valid="valid = $event"
      :isLoading="isLoading"
      :organization="organization"
      :countries="countries"
    />
    <BottomBar @cancel="$router.go(-1)" :valid="valid" :saving="saving" @save="storeOrganization"/>
  </div>
</template>

<script>
import Component, { mixins } from 'vue-class-component';
import OrganizationDetailsForm from '@/shared/OrganizationDetailsForm';
import BottomBar from '@/core/shared/components/BottomBar';
import FocusModeMixin from '@/core/shared/misc/FocusModeMixin';
import { isEqual } from 'lodash-es';

@Component({
  components: {
    OrganizationDetailsForm,
    BottomBar,
  },
})
export default class OrganizationDetails extends mixins(FocusModeMixin) {
  valid = false;
  saving = false;
  organizationChanges = {};

  get isLoading () {
    return this.$store.state.organization.isFetchingOrganization && !this.organization.contactFirstName;
  }

  get organization () {
    return { ...this.organizationInStore, ...this.organizationChanges };
  }

  get organizationInStore () {
    return this.$store.getters.currentOrganization;
  }

  get countries () {
    return this.$store.getters['entities/Country/all']();
  }

  created () {
    this.$store.commit('setTitle', this.$t('Organization Details'));
    this.$store.dispatch('getOrganizationDetailsForForm');
  }

  edit (property, value) {
    const dirty = !isEqual(this.organizationInStore[property], value);
    if (dirty) this.$set(this.organizationChanges, property, value);
    else this.$delete(this.organizationChanges, property);
  }

  async storeOrganization () {
    this.saving = true;
    try {
      await this.$store.dispatch('storeOrganization', { id: this.organization.id, ...this.organizationChanges });
      this.$store.commit('setFlash', {
        type: 'success',
        message: `${this.organization.name} ${this.$t('Saved')}`,
      });
      this.$router.go(-1);
    } finally {
      this.saving = false;
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "core/shared/styles";

.organization-details {
  padding-top: var(--spacingMd);
}
</style>
